import { keepPreviousData, useQuery } from '@tanstack/react-query';
import { getMembers } from '../services/member.service';
import { conversationKeys } from './conversation-keys';

export const useConversationMembers = (convId?: Nullable<string>) => {
  return useQuery({
    queryKey: conversationKeys.member(convId!),
    queryFn: () => getMembers(convId!),
    enabled: !!convId,
    placeholderData: keepPreviousData
  });
};
